<template>
  <div
    class="sticky-bottom-bar-icons"
    :style="{ gridTemplateColumns: `repeat(${buttonsCount}, 1fr)` }"
  >
    <button
      v-if="wizardProps.showRemove"
      class="mobile-bar-btn mobile-bar-btn-simple"
      type="button"
      @click="wizardProps.remove()"
    >
      <div class="mobile-bar-btn-content">
        <i class="feather icon-trash-2 mobile-bar-icon"></i>
        <span class="mobile-btn-label">{{ $t('RemoveGoogleListing') }}</span>
      </div>
    </button>

    <button
      class="mobile-bar-btn mobile-bar-btn-simple"
      type="button"
      @click="$emit('cancel')"
    >
      <div class="mobile-bar-btn-content">
        <i class="feather icon-x mobile-bar-icon"></i>
        <span class="mobile-btn-label">{{ $t(`$General.${wizardProps.isLastStep ? 'Close' : 'Cancel'}`) }}</span>
      </div>
    </button>

    <button
      v-if="wizardProps.activeTabIndex > 0"
      class="mobile-bar-btn mobile-bar-btn-simple"
      type="button"
      @click="wizardProps.prevTab()"
    >
      <div class="mobile-bar-btn-content">
        <i class="feather icon-arrow-left mobile-bar-icon"></i>
        <span class="mobile-btn-label">{{ $t('$General.Back') }}</span>
      </div>
    </button>

    <button
      v-if="!wizardProps.isLastStep"
      class="mobile-bar-btn mobile-bar-btn-simple"
      type="button"
      @click="wizardProps.nextTab()"
    >
      <div class="mobile-bar-btn-content">
        <i class="feather icon-arrow-right mobile-bar-icon"></i>
        <span class="mobile-btn-label">{{ $t('$General.Continue') }}</span>
      </div>
    </button>
  </div>
</template>

<script>
/**
 * Reviews settings create or edit wizard buttons
 *
 * @module views/modules/reviews/ReviewsSettingsCreateOrEditWizardButtons
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-prop {Object} wizardProps - wizard props
 */
export default {
  name: 'ReviewsSettingsCreateOrEditWizardButtons',
  i18n: {
    messages: {
      en: {
        RemoveGoogleListing: 'Remove Google listing',
      },
    },
  },
  components: {},
  props: {
    wizardProps: {
      type: Object,
      required: true,
    },
  },
  computed: {
    buttonsCount() {
      // Cancel/Close is always visible; Back and Continue are conditional
      return (this.wizardProps.showRemove ? 1 : 0)
        + 1
        + (this.wizardProps.activeTabIndex > 0 ? 1 : 0)
        + (!this.wizardProps.isLastStep ? 1 : 0);
    },
  },
};
</script>
